
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryReceiptModel } from '@/models/summary-receipt';

@Component
export default class SummaryReceipt extends Vue {
    @Prop({ default: () => new SummaryReceiptModel() })
    private summaryReceipt!: SummaryReceiptModel;
}
